export default __webpack_public_path__ + "static/media/Baker-bro.84066f6e.svg";